import { ServiceType } from "@agroyaar/sdk";
// @ts-ignore
import CroppingPattern from "@assets/images/cropping-pattern/cropping-pattern-report.png";
// @ts-ignore
import CroppingSuitability from "@assets/images/cropping-suitability/cropping-suitability-report-logo.png";

export function reportLogo(serviceType: ServiceType): string {
  const logoMap: Partial<Record<ServiceType, string>> = {
    CROPPING_PATTERN: CroppingPattern,
    CROPPING_SUITABILITY: CroppingSuitability,
  };

  return logoMap[serviceType] ?? CroppingPattern;
}
